import { ctxTargetAttributes } from '@/contexts/TargetAttributesContext';
import { Box } from '@mui/material';
import { JSX, useContext, useEffect } from 'react';
import { TargetAttributesTabs } from './TargetAttributesPopup';
import { TargetAttributesTabValue } from '@/types';
import CategorySelector from './CategorySelector';
import TargetAttributesTargetSelector from './TargetAttributesTargetSelector';
import { getMaxTargetNumber } from '@/generated/client/reports/reports';
import TargetAttributesMobileForm from './TargetAttributesMobileForm';

export default function TargetAttributesMobileBody({
  activeTab,
  setActiveTab,
}: {
  activeTab: TargetAttributesTabs;
  setActiveTab: (tab: TargetAttributesTabs) => void;
}) {
  const targetAttrCtx = useContext(ctxTargetAttributes);

  useEffect(() => {
    async function loadMaxTargetNumber() {
      const localMax = await getMaxTargetNumber();
      targetAttrCtx?.setMaxTargetNumber(localMax.data);
    }
    void loadMaxTargetNumber();
  }, []);

  if (!targetAttrCtx) return;

  switch (targetAttrCtx.tab) {
    case TargetAttributesTabValue.categorySelect:
      return <CategorySelector setActiveTab={setActiveTab} />;
    case TargetAttributesTabValue.result:
      return <TargetAttributesMobileForm selectedTargets={targetAttrCtx.selectedTargets} />;
    case TargetAttributesTabValue.entitySelect: {
      const selectors: Record<string, JSX.Element> = {
        TargetTab: <TargetAttributesTargetSelector />,
      };

      return <Box className="selector-box-target-attributes">{selectors[activeTab]}</Box>;
    }
  }
}
